import { Badge, Card, Stack, Text, Tooltip } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { SelectableCard } from '@/components/ui-shared/SelectableCard/SelectableCard'
import { VlmModelConfig } from './vlmModels'

export const MODEL_CARD_HEIGHT = 128

type VlmModelSelectorProps = {
  models: VlmModelConfig[]
  value: string
  selectedGpuCount: number
  onChange: (value: string) => void
}

export const VlmModelSelector = ({
  models,
  value,
  selectedGpuCount,
  onChange
}: VlmModelSelectorProps) => {
  return models.map((model) => {
    const isDisabled = model.min_required_gpus > selectedGpuCount

    return (
      <Tooltip
        key={model.id}
        disabled={!isDisabled}
        label={
          <FormattedMessage
            id="vlm.hardware.settings.model.gpuTooltip"
            values={{ count: model.min_required_gpus }}
          />
        }
      >
        <SelectableCard
          height={MODEL_CARD_HEIGHT}
          isSelected={value === model.id}
          disabled={isDisabled}
          onClick={() => onChange(model.id)}
        >
          <Card.Section py="xs" inheritPadding>
            <Stack gap={4} align="center">
              <Text size="sm" fw={600} c={model.color} ta="center">
                {model.name}
              </Text>

              <Text size="xs" c="dimmed" ta="center" lineClamp={2}>
                {model.description}
              </Text>

              {model.focus && (
                <Badge variant="transparent" color={model.color} size="sm">
                  <FormattedMessage
                    id="vlm.hardware.settings.model.focus"
                    values={{ focus: model.focus }}
                  />
                </Badge>
              )}

              <Badge variant="transparent" size="sm">
                <FormattedMessage
                  id="vlm.hardware.settings.model.gpuRequirement"
                  values={{ count: model.min_required_gpus }}
                />
              </Badge>
            </Stack>
          </Card.Section>
        </SelectableCard>
      </Tooltip>
    )
  })
}
